import React, { useState, useEffect } from 'react';
import './otpsignup.scss';
import axios from 'axios';
import OtpInput from 'react-otp-input';

const OtpSignup = ({ signUpData }) => {
    const [otpState, setOtpState] = useState({
        token: "",
        showError: false,
        errorMessage: "",
        showResent: false
    });
    const [isLoading, setIsLoading] = useState(false);
    const [signUpIsLoading, setSignUpIsLoading] = useState(false);
    const [signUpState, setSignUpState] = useState({
        showError: false,
        errorMessage: "",
    });

    const handleOtpChange = (otp) => {
        setOtpState(prev => ({ ...prev, token: otp }));
    };

    // Auto-trigger signup when OTP is complete
    useEffect(() => {
        if (otpState.token.length === 4 && !signUpIsLoading) {
            onSignUp();
        }
    }, [otpState.token]);

    const onResendOtp = async () => {
        try {
            setIsLoading(true);

            const trimmedContactNumber = signUpData.contactNumber?.trim()?.replace(/\s/g, '');
            const trimmedLowerEmail = signUpData.email?.trim()?.toLowerCase()?.replace(/\s/g, '');
            
            await axios('/otp_signup/send_otp', {
                method: 'POST',
                data: { email: trimmedLowerEmail, contact_number: trimmedContactNumber },
                headers: { Accept: 'application/json' },
            });

            setOtpState(prev => ({ ...prev, showResent: true }));
            setTimeout(() => {
                setOtpState(prev => ({ ...prev, showResent: false }));
                setIsLoading(false);
            }, 3000);

        } catch (e) {
            setIsLoading(false);

            setOtpState(prev => ({
                ...prev,
                showError: true,
                errorMessage: e.response?.data?.message ? e.response?.data?.message : e.message
            }));

            setTimeout(() => {
                setOtpState(prev => ({
                    ...prev,
                    showError: false,
                    errorMessage: ""
                }));
            }, 3000);
        }
    };

    const onSignUp = async () => {
        try {
            const { name, surname, addressPrimary, email, password, confirmPassword, termsAndConditions, contactNumber, token, employeeNumber } = signUpData;
            let trimmedContactNumber = contactNumber?.trim()?.replace(/\s/g, '')
            let trimmedLowerEmail = email?.trim()?.toLowerCase()?.replace(/\s/g, '')
            
            if (otpState.token == "") {
                throw new Error('Please enter OTP.');
            }

            if (name == "" || surname == ""
                || addressPrimary == "" || email == ""
                || password == "" || password.length < 6 || confirmPassword !== password
                || termsAndConditions == false || contactNumber == "") {
                throw new Error('Please complete all fields.');
            }

            setSignUpIsLoading(true);

            await axios('/otp_signup/save_user', {
                method: 'PUT',
                data: {
                    email: trimmedLowerEmail,
                    name,
                    surname,
                    password: password?.trim(),
                    address_primary: addressPrimary,
                    contact_number: trimmedContactNumber,
                    terms_and_conditions: termsAndConditions,
                    employee_number: employeeNumber,
                    token: otpState.token,
                },
                headers: { Accept: 'application/json' },
            });

            setSignUpIsLoading(false);
            window.location.replace('/users/sign_in');
        } catch (e) {

            setSignUpState((prevState) => ({
                ...prevState,
                showError: true,
                errorMessage: e.response?.data?.message ? e.response?.data?.message : e.message
            }));

            setTimeout(() => {
                setSignUpState((prevState) => ({
                    ...prevState,
                    showError: false,
                    errorMessage: ""
                }));
            }, 3000)
            
            setSignUpIsLoading(false);
        }
    }

    return (
        <div>
            <div className="text-center mb-6">
                <h2 className="text-2xl font-bold">Enter your OTP</h2>
                <p className="mt-2">
                    We sent an otp to {signUpData.email}.
                </p>
            </div>

            <div className="mb-4 w-full flex justify-center">
                <div className="w-full py-4">
                    <OtpInput
                        value={otpState.token}
                        onChange={handleOtpChange}
                        numInputs={4}
                        renderInput={(props) => (
                            <input
                                {...props}
                                className="flex-1 h-12 mx-2 text-xl rounded-lg border border-gray-300 text-center text-purple-500 focus:border-2 focus:border-purple-500 focus:outline-none" 
                            />
                        )}
                    />
                </div>
            </div>

            {signUpIsLoading && (
                <div className="mb-4">
                    <p className="text-blue-500 text-center">
                        <i className="fa fa-spinner fa-spin mr-2"></i>
                        Creating Account...
                    </p>
                </div>
            )}

            {otpState.showError && (
                <div className="mb-4">
                    <p className="text-red-500 text-center">
                        <i className="fas fa-exclamation-circle mr-2"></i>
                        {otpState.errorMessage}
                    </p>
                </div>
            )}

            {signUpState.showError && (
                <div className="mb-4">
                    <p className="text-red-500 text-center">
                        <i className="fas fa-exclamation-circle mr-2"></i>
                        {signUpState.errorMessage}
                    </p>
                </div>
            )}

            {otpState.showResent && (
                <div className="mb-4">
                    <p className="text-green-500 text-center">
                        <i className="fas fa-check-circle mr-2"></i>
                        OTP code has been resent successfully
                    </p>
                </div>
            )}

            <div className="flex-col">
                <span className="mr-4">Didn't get the otp?</span>
                <button
                    className="text-orange-400 underline"
                    onClick={onResendOtp}
                    disabled={isLoading}
                >
                    {isLoading ? (
                        <span>
                            Sending... <i className="fa fa-spinner fa-spin ml-1"></i>
                        </span>
                    ) : (
                        'Click to resend'
                    )}
                </button>
            </div>
        </div>
    );
};

export default OtpSignup;